/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import cloudinary from "cloudinary-core";
const { Cloudinary } = cloudinary;

function useCloudinary() {
	const cld = new Cloudinary({
		cloud_name: "djbs",
		secure: true,
	});

	return cld;
}

/**
 * @description Get the public ID of the cloudinary image
 * @param meta Meta value from API
 * @returns Public ID
 */
function getImageId(meta: string) {
	if (meta) {
		const metaJson = JSON.parse(meta);
		return metaJson?.images[0].cloudinary;
	} else {
		return "";
	}
}

export { getImageId, useCloudinary };
